import { autoinject } from 'aurelia-framework';
import { BaseApiService } from './base-api-service';
import { Models } from 'models/core';
import { AuthHttpClient } from './auth-http-client';
import { QueryFilter } from 'lib/tables/DataFilter';

@autoinject
export class ForeignObjectTypeServiceService extends BaseApiService<Models.ForeignObjectTypeService> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, Models.ForeignObjectTypeService);
  }

  public getStandardForeignObjectTypeServices() {
    return this.httpClient.execWithResponseMeta<Models.ForeignObjectTypeService[]>(`${Models.ForeignObjectTypeService.ApiUrl}/standard`, {
      method: 'GET',
    });
  }

  public getInvoiceableForeignObjectTypeServices(erpId: number) {
    return this.httpClient.execWithResponseMeta<Models.ForeignObjectTypeService[]>(
      `${Models.ForeignObjectTypeService.ApiUrl}/invoiceable/${erpId}`,
      {
        method: 'GET',
      }
    );
  }

  public getForeignObjectTypeServiceList(filters: QueryFilter) {
    return this.httpClient.execWithResponseMeta<any[]>(`${Models.ForeignObjectTypeService.ApiUrl}/list${filters.asQueryString}`, {
      method: 'GET',
    });
  }

  public async checkDuplicate(data: Models.CheckDuplicateForeignObjectTypeService) {
    return await this.httpClient.exec<{ IsDuplicate: boolean }>(`${Models.ForeignObjectTypeService.ApiUrl}/checkDuplicate`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }
}
